import { render, staticRenderFns } from "./GoetelButton.vue?vue&type=template&id=528c1955&scoped=true&"
import script from "./GoetelButton.vue?vue&type=script&lang=js&"
export * from "./GoetelButton.vue?vue&type=script&lang=js&"
import style0 from "./GoetelButton.vue?vue&type=style&index=0&id=528c1955&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c1955",
  null
  
)

export default component.exports